import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Utilities } from '../utils/utilities';
import { environment } from '@environments/environment';

export const idBasedPageAccessGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const util = inject(Utilities);

  if ((!state.url?.toLowerCase()?.includes('user') && !state.url?.toLowerCase()?.includes('forward-generation')) || (state.url?.toLowerCase()?.includes('user') && await util.fetchFeatureFlagDetails(environment.gitAccessDetails, environment.gitProjId, ('scc_add_new_user_access' + (environment.name ? '_' + environment.name : '')))) || (state.url?.toLowerCase()?.includes('forward-generation') && await util.fetchFeatureFlagDetails(environment.gitAccessDetails, environment.gitProjId, ('scc_forward_generation_access' + (environment.name ? '_' + environment.name : '')))))
    return true;
  else if (util.institutionDetails() && JSON.parse(util.institutionDetails())?.institutionId)
    return router.createUrlTree(['/edit-institution/' + JSON.parse(util.institutionDetails())?.institutionId]);
  else
    return router.createUrlTree(['/home']);
}